import { stimuliBackendBaseUrl } from '../stimuli/stimulusUploads';

function backendBaseUrl(baseUrl) {
  return (baseUrl || stimuliBackendBaseUrl()).replace(/\/+$/, '');
}

async function requestJson(url, options, fetchImpl, fallback) {
  const response = await fetchImpl(url, options);
  let body = {};
  try {
    body = await response.json();
  } catch (_error) {
    body = {};
  }
  if (!response.ok) {
    const detail = typeof body?.detail === 'string' && body.detail
      ? body.detail
      : `${fallback} (HTTP ${response.status}).`;
    throw new Error(detail);
  }
  return body;
}

export function fetchContentManifest({
  baseUrl,
  token,
  fetchImpl = globalThis.fetch,
}) {
  return requestJson(
    `${backendBaseUrl(baseUrl)}/content/manifest`,
    { headers: { Authorization: `Bearer ${token}` } },
    fetchImpl,
    'Content manifest could not be loaded.',
  );
}

export function updateStimulusState({
  baseUrl,
  token,
  hash,
  enabled,
  labelingComplete,
  fetchImpl = globalThis.fetch,
}) {
  const body = {};
  if (enabled !== undefined) {
    body.enabled = enabled;
  }
  if (labelingComplete !== undefined) {
    body.labeling_complete = labelingComplete;
  }
  return requestJson(
    `${backendBaseUrl(baseUrl)}/admin/stimuli/${encodeURIComponent(hash)}`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    fetchImpl,
    'Stimulus state could not be updated.',
  );
}
